/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_Search_SuccessInputs */

const es_tools_legajox_search_success = /** @type {(inputs: Tools_Legajox_Search_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos de Legajox encontrados`)
};

const en_tools_legajox_search_success = /** @type {(inputs: Tools_Legajox_Search_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legajox documents found`)
};

/**
* | output |
* | --- |
* | "Legajox documents found" |
*
* @param {Tools_Legajox_Search_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_search_success = /** @type {((inputs?: Tools_Legajox_Search_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_Search_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_search_success(inputs)
	return en_tools_legajox_search_success(inputs)
});
export { tools_legajox_search_success as "tools.legajox.search_success" }